<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.question_show") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <base-select-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.question_category')"
            v-model.trim="data.categories"
            :optionsList="data.categories"
            disabled
            multiple
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.level')"
            v-model.trim="data.level.name"
            required
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.question_type')"
            v-model.trim="data.type.name"
            required
            disabled
          />
          <base-image-upload-input
            col="12"
            v-if="data.type?.value == 'video'"
            identifier="video"
            :placeholder="$t('PLACEHOLDERS.video_question')"
            :acceptVideo="true"
            @selectImage="selectVideo"
            :preSelectedImage="data.video"
            disabled
          />
          <UploadAudio
            col="12"
            v-if="data.type?.value == 'record'"
            identifier="record"
            :placeholder="$t('PLACEHOLDERS.record_question')"
            :accepctAudio="true"
            @selectAudio="selectAudio"
            :multiple="false"
            :urls="[data.record]"
          />
          <div v-if="data.type.value == 'image'">
            <h3>الصور</h3>
            <UploadsPhotos
              :show="true"
              col="12"
              identifier="images"
              :urls="imgUrls"
              multiple
              :placeholder="$t('PLACEHOLDERS.image')"
              disabled
            />
          </div>
          <base-input
            col="6"
            v-if="data.type"
            :type="data.type?.value != 'text' ? 'text' : 'textarea'"
            :placeholder="
              $t(
                data.type?.value == 'text'
                  ? 'PLACEHOLDERS.question_text_english'
                  : 'PLACEHOLDERS.descEn'
              )
            "
            v-model.trim="data.questionEn"
            required
            disabled
          />
          <base-input
            col="6"
            v-if="data.type"
            :type="data.type?.value != 'text' ? 'text' : 'textarea'"
            :placeholder="
              $t(
                data.type?.value == 'text'
                  ? 'PLACEHOLDERS.question_text_arabic'
                  : 'PLACEHOLDERS.descEn'
              )
            "
            v-model.trim="data.questionAr"
            required
            disabled
          />

          <base-input
            col="6"
            :type="'textarea'"
            :placeholder="$t('PLACEHOLDERS.answer_text_arabic')"
            v-model.trim="data.answerAr"
            required
            disabled
          />
          <base-input
            col="6"
            :type="'textarea'"
            :placeholder="$t('PLACEHOLDERS.answer_text_english')"
            v-model.trim="data.answerEn"
            required
            disabled
          />

          <base-select-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.objecting_clients')"
            v-model.trim="data.objected_users"
            :optionsList="data.objected_users"
            disabled
            multiple
          />
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import moment from "moment";
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";

export default {
  name: "CreatePackage",
  components: { UploadsPhotos },

  data() {
    return {
      types: [
        {
          value: "text",
          name: this.$t("PLACEHOLDERS.text_queston"),
        },
        {
          value: "video",
          name: this.$t("PLACEHOLDERS.video_question"),
        },
        {
          value: "image",
          name: this.$t("PLACEHOLDERS.image_question"),
        },
        {
          value: "record",
          name: this.$t("PLACEHOLDERS.record"),
          id: "record",
        },
      ],
      levels: [
        {
          name: this.$t("PLACEHOLDERS.low"),
          value: "easy",
        },
        {
          name: this.$t("PLACEHOLDERS.medium"),
          value: "medium",
        },
        {
          name: this.$t("PLACEHOLDERS.hard"),
          value: "hard",
        },
      ],
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",
      imgUrls: [],

      // Start:: Data Collection To Send
      data: {
        images: [
          {
            path: null,
            file: null,
          },
        ],
        type: null,
        questionAr: null,
        questionEn: null,
        categories: [],
        objected_users: [],
        helping_answers: [],
        discount: null,
        question: null,
        record: null,
        video: {
          path: null,
          file: null,
        },
        image: {
          path: null,
          file: null,
        },
        name_ar: null,
        name_en: null,
        discount: null,
        discount_start_date: null,
        discount_end_date: null,
        number_of_available_usages: null,
        price: null,
        number_of_used: null,
        created_at: null,

        active: true,
      },
      // End:: Data Collection To Send
      capacities: [],
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  methods: {
    async getPackage() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `questions/${this.$route.params.id}`,
        });
        this.data.categories = res.data?.data.data?.categories;
        this.data.level = res.data.data?.data?.level;
        this.data.type = res.data.data?.data?.type;
        this.data.video.path = res.data.data.data.video;
        this.data.record = res.data.data.data?.record;

        this.data.questionAr = res.data.data.data.question_ar;
        this.data.questionEn = res.data.data.data.question_en;
        this.data.descAr = res.data.data.data.description_ar;
        this.data.descEn = res.data.data.data.description_en;
        this.data.answerAr = res.data.data.data.answer_ar;
        this.data.answerEn = res.data.data.data.answer_en;
        this.data.discount = res.data.data.data?.discount;
        this.data.question = res.data.data.data?.question;
        this.data.images = res.data.data.data.image.map((image) => {
          return { file: null, path: image.url, id: image.id };
        });
        this.imgUrls = res.data.data.data.image.map((image) => image.url);

        this.data.record = res.data.data.data?.record;

        this.data.video = res.data.data.data?.video;
        this.data.helping_answers = res.data.data.data?.helping_answers;
        this.data.answer = res.data.data?.data?.answer;

        this.data.objected_users = res.data.data?.data?.objected_users.map(
          (user) => {
            console.log(user);
            return {
              id: user.user_id,
              name: `${user.user_name} - ${user.objection_date}`,
            };
          }
        );
        this.data.type = this.types?.find(
          (type) => type.value == res.data.data.data.type
        );
        this.data.level = this.levels?.find(
          (level) => level.value == res.data.data.data.level
        );
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },
  },

  created() {
    // Start:: Fire Methods
    // End:: Fire Methods
    this.getPackage();
  },
};
</script>
